

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ActivitySwitch from '@/components/common/edit/ActivitySwitch.vue';
@Component({
  components: {
    'activity-switch': ActivitySwitch,
  },
})
export default class EditTitleModal extends Vue {
  @Prop(Boolean) show!: boolean;
  @Prop(String) type!: string;
  @Prop(Boolean) switch!: boolean;
  @Prop(String) title!: string;

  @Getter('mainTextColor') mainTextColor!: string;
  @Getter('section') section: any;

  @Getter('institutionSwitch') institutionSwitch!: boolean;

  @Action('changeContactTitle') changeContactTitle!: Function;
  @Action('changeContactSwitch') changeContactSwitch!: Function;
  @Action('changeInstitutionTitle') changeInstitutionTitle!: Function;
  @Action('changeInstitutionSwitch') changeInstitutionSwitch!: Function;
  @Action('changeActivityTitle') changeActivityTitle!: Function;
  @Action('changeActivitySwitch') changeActivitySwitch!: Function;

  updated() {
    if (this.updateState) {
      this.switchState = this.switch;
      this.editTitle = this.title;
    }
  }

  editTitle: string = this.title;
  switchState: boolean = this.switch;
  updateState: boolean = true;

  get length() {
    return this.editTitle.length;
  }

  handleInputChange(val: string) {
    this.updateState = false;
    this.editTitle = val;
  }
  handleSwitchStatus(val: boolean) {
    this.updateState = false;
    this.switchState = val;
  }
  handleHideModal(): void {
    this.$emit('hide');
  }
  handleOk() {
    if (!this.editTitle) return Vue.$toast.error('模块标题不能为空');
    if (this.type === 'contact') {
      // 联系方式
      this.changeContactTitle(this.editTitle);
      this.changeContactSwitch(this.switchState);
    } else if (this.type === 'institution') {
      // 机构简介
      this.changeInstitutionTitle(this.editTitle);
      this.changeInstitutionSwitch(this.switchState);
    } else if (this.type === 'activity') {
      // 活动说明
      this.changeActivityTitle(this.editTitle);
      this.changeActivitySwitch(this.switchState);
    }
    this.$emit('hide');
  }
}
